import { __awaiter } from "tslib";
import { ImageCapture } from "image-capture";
export function canvasToBlob(canvas) {
    return new Promise((resolve, reject) => {
        try {
            canvas.toBlob((blob) => blob instanceof Blob
                ? resolve(blob)
                : reject(new Error("Failed to extract image from canvas")));
        }
        catch (error) {
            reject(error);
        }
    });
}
export function canvasToUrl(canvas) {
    return canvas.toDataURL();
}
function copyDimensions(canvas, source) {
    if (source instanceof HTMLVideoElement) {
        canvas.width = source.videoWidth;
        canvas.height = source.videoHeight;
    }
    else if (source instanceof HTMLImageElement) {
        canvas.width = source.naturalWidth;
        canvas.height = source.naturalHeight;
    }
    else if (!(source instanceof SVGImageElement)) {
        canvas.width = source.width;
        canvas.height = source.height;
    }
}
function getContext(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        throw new Error("Failed to extract image from canvas due to null context");
    }
    return ctx;
}
export function useCanvas(source) {
    const canvas = document.createElement("canvas");
    copyDimensions(canvas, source);
    const context = getContext(canvas);
    context.drawImage(source, 0, 0);
    return canvas;
}
function useImageCapture(videoTrack) {
    return __awaiter(this, void 0, void 0, function* () {
        // eslint-disable-next-line compat/compat
        return new ImageCapture(videoTrack).takePhoto({
            imageWidth: 1920,
            imageHeight: 1080,
        });
    });
}
export function captureBlobImage(videoElement) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!(videoElement.srcObject instanceof MediaStream)) {
            throw new Error("Unsupported media source on video element");
        }
        try {
            return yield useImageCapture(videoElement.srcObject.getVideoTracks()[0]);
        }
        catch (_a) {
            return canvasToBlob(useCanvas(videoElement));
        }
    });
}
export function captureURLImage(videoElement, options = { mirror: false }) {
    const cnv = useCanvas(videoElement);
    return canvasToUrl(options.mirror ? mirror(cnv) : cnv);
}
/** reverse canvas on y axis, without clearing */
export function mirror(canvas) {
    const ctx = getContext(canvas);
    ctx.transform(-1, 0, 0, 1, canvas.width, 0);
    ctx.drawImage(canvas, 0, 0);
    return canvas;
}
export function merge(a, b) {
    const base = document.createElement("canvas");
    copyDimensions(base, a);
    const ctx = getContext(base);
    ctx.drawImage(a, 0, 0, base.width, base.height);
    ctx.drawImage(b, 0, 0, base.width, base.height);
    return base;
}
